module.exports = __webpack_public_path__ + "assets/images/project/map-logo-svg/desktop1.png?v=30c2d433";